<script lang="ts">
  export let legend: string
</script>

<fieldset class="grid sm:grid-cols-3 sm:gap-inline-8">
  <div class="text-gray-800 italic text-sm2 sm:mt-0">
    <legend class="text-lger font-semibold text-gray-700 not-italic mb-1">{legend}</legend>
    <div><slot name="description" /></div>
  </div>

  <div class="grid gap-4 sm:col-span-2 mt-1 sm:mt-0">
    <slot />
  </div>
</fieldset>
